const Role = {
    GENERAL: "user",
    ADMIN: "admin"

}

export default Role